import React, { Component } from 'react';
import { getInvoiceInfo } from '../../../../API/FetchCall';
import PdfContainer from './PdfContainer';
import Doc from './DocService';

class ComSprtCompare extends Component {

  constructor(props) {
    super(props);
    console.log('this.props', this.props);
    this.state = {
      compareData: this.props.viewData.compareData,
      ratingData: this.props.viewData.ratingData,
      date: this.props.viewData.date
    };
  }
  componentDidMount() {

  }
  createPdf = (html) => Doc.createPdf(html);


  render() {
    const { compareData, ratingData } = this.state;
    console.log('this.state.compareData re', compareData)
    let dataLen = compareData.length;
    let scl = dataLen > 0 ? compareData[0].name : '';
    return (

      <React.Fragment>
        <div className="row invoice-container compare-container">
          <div className="back-drop">
            <h2>{`Confidential - Bewise prepared for ${scl.trim()}`}</h2>
          </div>
          <div className='row'>
            <p>Date : {this.state.date}</p>
            <table className='table table-bordered comparetable'>
              <tr>
                <th>Name</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.name}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Category</th>
                {compareData.map((item, i) => {
                  return (
                    <td>{item.category}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Mode of Payment</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.payment_name ? item.payment_name : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Established Year</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.est_year ? item.est_year : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>No of Classes/ Month</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.noclass ? item.noclass : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Event Fee</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.avg_fee == 0 || item.avg_fee == 'NA' ? 'NA' : (<span>&#8377; {item.avg_fee}</span>)}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th colSpan={1 + compareData.length}>Rating</th>
              </tr>
              <tr>
                <th>Covid19 responses</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.covid19}</td>
                  )
                })}
              </tr>
              <tr>
                <th>
                  Quality of Teacher (OR)
                  Counsellor (OR) Comfort with Trainer / Teacher
                </th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.qty_teachers}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Quality of Teaching (OR) Counselling (OR) Method of Teaching / Coaching / Counselling</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.qty_teaching}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Child Safety</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.child_safety}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Facilities & Connectivity (OR) Quality of Connectivity / Campus</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.facilities}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Ontime / Punctuality (OR) Punctuality</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.ontime_punctuality}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Ease of Interaction (OR) Information @ Website</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.qty_intraction}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Overall Rating</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.overall_expirence}</td>
                  )
                })}
              </tr>
            </table>
          </div>
        </div>
      </React.Fragment>

    );
  }
}

export default ComSprtCompare;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/benchmark/community_support_compare.jsx